<template>
  <div>
    <v-card style="width:100%;height:90px" class="secondary">
      <v-layout row wrap style="height:40px;">
        <v-flex xs10 style="padding:10px;">
          <div class="title" style="color:white">Last 50 Recharges</div>
        </v-flex>
        <v-flex xs2>
          <v-btn icon @click="fetchstatement" style="float:right">
            <v-icon color="white">refresh</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout row wrap style="height:40px;">
        <v-flex xs12 style="padding-top:8px">
          <input type="text" v-model="search" class="search" placeholder="Search All Column" />
        </v-flex>
        <v-layout row wrap>
          <v-spacer></v-spacer>
        </v-layout>
      </v-layout>
    </v-card>
    <v-data-table :headers="headers" :items="statementlist" :search="search">
      <template slot="items" slot-scope="props">
        <td>{{ props.item.orderid }}</td>
        <td>{{ props.item.service }}</td>
        <td>{{ props.item.mobile }}</td>
        <td>{{ props.item.type }}</td>
        <td>{{ props.item.amount }}</td>
        <td>
          <v-btn small :class="checkstatus(props.item.status)">{{ props.item.status }}</v-btn>
        </td>
        <td>{{ props.item.tid }}</td>
        <td>{{ new Date(parseInt(props.item.time)) | moment("DD-MM-YYYY, h:mm:ss a")}}</td>
        <td>
          <v-btn @click="getsummary(props.item.orderid)" small color="primary">View</v-btn>
          <v-btn @click="openComplaint(props.item.orderid)" small class="pl-3 pr-3 error">complaint</v-btn>
        </td>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please wait
          <v-progress-linear indeterminate color="white" class="mb-0" />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="viewstatus" width="400">
      <v-card>
        <div ref="receipt">
          <span style="padding:10px;float:left;font-size:20px">Receipt</span>
          <div>
            <img :src="e_img" width="100%" />
          </div>
          <table class="print_table">
            <tr v-for="(item,key) in summary" :key="key">
              <td>{{key}}</td>
              <td>{{item}}</td>
            </tr>
          </table>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat="flat" @click="viewstatus = false">Cancel</v-btn>
          <v-btn color="green darken-1" flat="flat" @click="print">Print</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="viewcomplaint" width="400">
      <v-card>
        <v-card-title class="title">Register complaint</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-textarea v-model="remark" hide-details no-resize label="Remark"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat="flat" @click="viewcomplaint = false">Cancel</v-btn>
          <v-btn color="green darken-1" flat="flat" @click="registerComplaint()">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Print v-if="printbill" :doc="printdoc"></Print>
  </div>
</template>
<script>
import Print from "../components/PrintBill";
export default {
  data() {
    return {
      headers: [
        { text: "Order No", value: "orderno", align: "left" },
        { text: "Service", value: "service" },
        { text: "MobileNo", value: "mobile" },
        { text: "Type", value: "type" },
        { text: "Amount", value: "amount" },
        { text: "Status", value: "status" },
        { text: "TransactionID", value: "transactionid" },
        { text: "Recharge Time", value: "time" },
        { text: "Action", value: "action" }
      ],
      rechargeId: "",
      dialog: false,
      viewstatus: false,
      statementlist: [],
      modal: false,
      search: "",
      viewcomplaint: false,
      summary: {},
      printbill: false,
      printdoc: {},
      remark: ""
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    e_img() {
      return this.$store.getters.print_image;
    }
  },
  methods: {
    openComplaint(id) {
      const vm = this;
      vm.rechargeId = id;
      vm.viewcomplaint = true;
    },
    checkstatus(status) {
      status = status.toLowerCase();
      if (status == "success") return "success";
      if (status == "pending") return "grey";
      if (status == "inprocess") return "warning";
      if (status == "failed") return "error";
      return "primary";
    },
    notification(type, message) {
      this.$notify({
        group: "foo",
        title: "Important message",
        text: message,
        duration: 5000,
        type: type
      });
    },
    pushstatement(value) {
      let vm = this;
      vm.statementlist = [];
      for (let i = 0; i < value.length; i++) {
        let doc = value[i];
        let time = doc.RechargeDate.replace("/Date(", "").replace(")/", "");
        let phone = doc.MobileNo;
        if (phone.split("-").length > 2) {
          phone = phone.split("-")[1];
        }
        vm.statementlist.push({
          amount: doc.Amount,
          orderid: doc.Id,
          mobile: phone,
          time: time,
          service: doc.ServiceName,
          type: doc.ServiceType,
          status: doc.Status,
          tid: doc.TransactionId
        });
      }
    },
    print() {
      const css = `
               .print_table{
                  width: 100%;
                  border-collapse: collapse;
                  border-top:1px solid lightgray;
               }
               .print_table tr{
               border-bottom: 1pt solid lightgray;
               }
               .print_table td{
                  height: 45px!important;
               }
               .print_table td:nth-child(1), td:nth-child(3) {
                  color: #444444;
                  font-weight: bold;
               }
               .print_table td:nth-child(2) , td:nth-child(4){
                  color: grey;
                `;
      const prtHtml = this.$refs.receipt.innerHTML;

      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=1000,height=900,toolbar=0,scrollbars=0,status=0"
      );

      WinPrint.document.write(`<!DOCTYPE html>
                <html>
                <head>
                    <style>
                    ${css}
                    </style>
                </head>
                <body>
                  <div  style="width:400px">
                        ${prtHtml}
                  </div>
                </body>
                </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      setTimeout(function() {
        WinPrint.print();
        WinPrint.close();
      }, 500);
    },
    getsummary(id) {
      let vm = this;
      let doc = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        Source: "json",
        Autono: id
      };
      vm.dialog = true;
      vm.$store
        .dispatch("axiospost", {
          url: "getRechargesById",
          data: doc
        })
        .then(function(res) {
          vm.dialog = false;
          let doc = res.data[0];
          let phone = doc.MobileNo;
          if (phone.split("-").length > 2) {
            phone = phone.split("-")[1];
            vm.printbill = true;
            let time = doc.RechargeDate.replace("/Date(", "").replace(")/", "");
            vm.printdoc = {
              service: doc.ServiceName,
              date: time,
              orderid: doc.Id,
              status: doc.Status,
              amount: doc.Amount,
              phone: phone,
              reference: doc.TransactionId
            };
          } else {
            vm.viewstatus = true;
            vm.summary = {
              "Recharge Status": doc.Status,
              "Recharge Phone": phone,
              "Recharge Amount": doc.Amount,
              Surcharge: doc.Surcharge,
              Commission: doc.Commission,
              "Opening Balance": doc.OpeningBal,
              "Closing Balance": doc.ClosingBal,
              "Client Transaction Id": doc.ClientTxId,
              "Transaction Id": doc.TransactionId
            };
          }
        })
        .catch(function(error) {
          vm.notification("error", error.message);
          vm.dialog = false;
        });
    },
    registerComplaint() {
      const vm = this;
      if (!vm.user.phone)
        return vm.notification("warn", "Authentication Required!");
      let doc = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        Source: "json",
        RechargeId: vm.rechargeId,
        remark: vm.remark
      };
      vm.dialog = true;
      vm.$store
        .dispatch("axiospost", {
          url: "Register_Complain",
          data: doc
        })
        .then(function(res) {
          vm.notification("success", res.data.Message);
          vm.viewcomplaint = false;
          vm.dialog = false;
          vm.remark = "";
          vm.rechargeId = "";
        })
        .catch(function(error) {
          vm.viewcomplaint = false;
          vm.notification("error", error.message);
          vm.dialog = false;
        });
    },
    fetchstatement() {
      let vm = this;
      if (!vm.user.phone)
        return vm.notification("warn", "Authentication Required!");
      let doc = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        Source: "json",
        recordcnt: "50"
      };
      vm.dialog = true;
      vm.$store
        .dispatch("axiospost", {
          url: "Last5",
          data: doc
        })
        .then(function(res) {
          vm.dialog = false;
          vm.pushstatement(res.data);
        })
        .catch(function(error) {
          vm.notification("error", error.message);
          vm.dialog = false;
        });
    }
  },
  mounted() {
    let vm = this;
    vm.fetchstatement();
  },
  components: {
    Print
  }
};
</script>

<style scoped>
.search {
  width: 250px;
  float: right;
  margin-right: 10px;
  height: 34px;
  background: white;
  outline: none;
  margin-left: 20px;
  padding-left: 10px;
  font-size: 1em;
}
.print_table {
  width: 100%;
  border-collapse: collapse;
  border-top: 1px solid lightgray;
}
.print_table tr {
  border-bottom: 1pt solid lightgray;
}
.print_table td {
  height: 45px !important;
}
.print_table td:nth-child(1),
td:nth-child(3) {
  color: #444444;
  font-weight: bold;
}
.print_table td:nth-child(2),
td:nth-child(4) {
  color: grey;
}
</style>
